export default __webpack_public_path__ + "static/media/icon-terminal.d6c32f54.svg";